export default {
  addProject: {
    appUrl: '推广产品链接',
    appUrlPlaceholder: '请输入产品的应用商店链接',
    invalidLinkFormat: '链接格式不正确',
    languages: '目标语言',
    ratios: '图片尺寸',
    submit: '创建',
  },
  projectList: {
    table: {
      languages: '语言',
      ratios: '尺寸',
    },
  },
}
